import { HttpTransportType, HubConnection, HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr'
import { GetSessionToken } from 'utils/auth'

export default class HubClient {
	private connection: HubConnection

	constructor(url: string) {
		const sessionToken = GetSessionToken()

		if (!sessionToken) {
			throw new Error('Failed to build hub connection because session token was null')
		}

		this.connection = new HubConnectionBuilder()
			.withUrl(url, {
				accessTokenFactory: () => sessionToken,
				skipNegotiation: true,
				transport: HttpTransportType.WebSockets,
			})
			.withAutomaticReconnect()
			.build()
	}

	get isConnected() {
		return this.connection.state === HubConnectionState.Connected
	}

	on = (methodName: string, callback: (...args: any) => void) => {
		this.connection.on(methodName, callback)
	}

	start = () => {
		if (this.connection.state === HubConnectionState.Disconnected) {
			this.connection.start()
		}
	}

	stop = () => {
		return this.connection.stop()
	}

	stream = (methodName: string, ...args: any) => {
		return this.connection.stream(methodName, ...args)
	}
}
